export default function TranscriptIcon(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.33269 1.51269V4.26639C9.33269 4.63976 9.33269 4.82644 9.40534 4.96905C9.46924 5.09448 9.57124 5.19648 9.69669 5.26038C9.83929 5.33303 10.026 5.33303 10.3993 5.33303H13.153M9.33269 11.333H5.33269M10.666 8.66633H5.33269M13.3327 6.65848V11.4663C13.3327 12.5864 13.3327 13.1465 13.1147 13.5743C12.9229 13.9506 12.617 14.2566 12.2406 14.4483C11.8128 14.6663 11.2528 14.6663 10.1327 14.6663H5.86604C4.74591 14.6663 4.18586 14.6663 3.75804 14.4483C3.38171 14.2566 3.07575 13.9506 2.88401 13.5743C2.66602 13.1465 2.66602 12.5864 2.66602 11.4663V4.53301C2.66602 3.4129 2.66602 2.85285 2.88401 2.42503C3.07575 2.0487 3.38171 1.74274 3.75804 1.55099C4.18586 1.33301 4.74591 1.33301 5.86604 1.33301H8.00719C8.49639 1.33301 8.74099 1.33301 8.97114 1.38827C9.17524 1.43726 9.37029 1.51807 9.54924 1.62773C9.75109 1.75141 9.92404 1.92436 10.2699 2.27026L12.3954 4.39575C12.7413 4.74165 12.9143 4.9146 13.0379 5.11643C13.1476 5.29538 13.2284 5.49048 13.2774 5.69453C13.3327 5.92473 13.3327 6.16933 13.3327 6.65848Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}